import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";

import Field from "../ui/Field";
import axios from "../helpers/axios";
import { AuthContext } from "../helpers/auth";

const SignIn = () => {
  const [isOpen, setIsOpen] = useState(true);

  // AuthContext
  const auth = useContext(AuthContext);

  //State
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loadingClassName, setLoadingClassName] = useState("");

  const submitHandler = (event) => {
    event.preventDefault();

    setLoadingClassName("is-loading");

    axios
      .post("/api/user/signin/", { username, password })
      .then((response) => {
        const { data } = response;

        auth.setAuth(data.token, data.user);
      })
      .catch((error) => {
        console.error(error);
        setErrors({
          invalidCredentials:
            "Nombre de usuario o contraseña incorrecta. Favor de verificar",
        });
      })
      .then(() => {
        setLoadingClassName("");
      });
  };

  return (
    <div
      style={{
        backgroundColor: "#f0f4f5",
        backgroundImage: "url(/backscreen.png)",
        backgorundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <div
        className="container"
        style={{ maxWidth: "400px", paddingTop: "10%" }}
      >
        <div className="box py-6 px-6">
          <div className="has-text-centered">
            <div className="container">
              <figure
                className="image"
                style={{ maxWidth: "50%", margin: "0 auto 3rem auto" }}
              >
                <img src="/logo256.png" alt="Rastreo Tracsa" />
              </figure>

              <div className="field">
                <div className="control">
                  <Link to="/order" className="button is-info is-fullwidth">
                    Rastrear Pedido
                  </Link>
                </div>
              </div>

              {isOpen ? (
                <div className="field">
                  <div className="control">
                    <button
                      onClick={() => setIsOpen(false)}
                      className={`button is-text is-fullwidth ${loadingClassName}`}
                    >
                      Iniciar Sesión
                    </button>
                  </div>
                </div>
              ) : (
                <form
                  onSubmit={submitHandler}
                  className="center-element has-text-left"
                >

                  {errors.invalidCredentials ? (
                    <div className="notification is-danger">
                      <button
                        className="delete"
                        onClick={() =>
                          setErrors((oldState) => {
                            return { ...oldState, invalidCredentials: "" };
                          })
                        }
                      ></button>
                      <p>{errors.invalidCredentials}</p>
                    </div>
                  ) : null}

                  <Field
                    type="text"
                    placeholder="Usuario correo"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                    error={errors.username}
                    errorClasses="input-error-text"
                    classes={
                      errors.username ? "input-error" : "input-default-style"
                    }
                  />

                  <Field
                    type="password"
                    placeholder="Contraseña correo"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    error={errors.password}
                    errorClasses="input-error-text"
                    classes={
                      errors.password ? "input-error" : "input-default-style"
                    }
                  />

                  <div className="field">
                    <div className="control">
                      <button
                        className={`button is-primary is-fullwidth ${loadingClassName}`}
                      >
                        Entrar
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
